import React from 'react';
import { useFileOptionContext } from 'Components/UI/FileOption/FileOptionContext';
import DocumentList from 'Components/UI/DocumentList';
import LoadingOverlay from 'Components/UI/LoadingOverlay/LoadingOverlay';
import PropTypes from 'prop-types';

const FileOptionList = ({ onLink }) => {
  const {
    fileOptionCollection, setLoading, isLoading,
  } = useFileOptionContext();


  return (
    <>
      {isLoading && <LoadingOverlay />}
      <DocumentList
        documentCollection={fileOptionCollection}
        onDelete={setLoading}
        onSubmit={setLoading}
        onFinally={() => {
          onLink();
        }}
      />
    </>
  );
};

FileOptionList.defaultProps = {
};

FileOptionList.propTypes = {
  onLink: PropTypes.func,
};

export default FileOptionList;
